module.exports = __webpack_public_path__ + "img/bouvet-island.de0a0b37.svg";